'use strict';
import angular from 'angular';
import snapGenderHtmlUrl from './views/snapGenderList.html';

var app = angular.module('app.snapGender.component', []);

app.component('snapGender', {
    bindings: {
        showActions: '<',
        selectedSnapGender: '=',
        clusterId: '=',
        isFormEdit: '=',
        clientId: '='
    },
    templateUrl: snapGenderHtmlUrl,

    controller: function (ProductService) {
        var self = this;

        self.selectedGender = '';

        self.toggleGenderList = function () {
            self.showActions = !self.showActions;
        };

        self.selectGender = function (gender) {
            self.selectedGender = gender.name;
            self.showActions = false;

            self.selectedSnapGender[0].snapGenderList = self.snapGenderList.filter(function (item) {
                return item.name === self.selectedGender;
            });
        };

        self.snapGenderList = [];

        self.getSnapGender = function () {
            var selectedSnapGender = self.selectedGender;
            ProductService.getSnapGenderContents({
                clientId: self.clientId,
                clusterId: self.clusterId
            }).then(function (success) {
                if (success && success.data && success.data.length > 0) {
                    _.each(success.data, function (content) {
                        var genders = {
                            id: content.id,
                            name: content.name
                        };
                        self.snapGenderList.push(genders);
                    });
                }
            }, function (error) {
            });
        }

        self.initComponent = function () {
            if (self.selectedSnapGender && !_.isEmpty(self.selectedSnapGender)) {
                self.selectedSnapGender = JSON.parse(self.selectedSnapGender);
                self.showActions = self.isFormEdit;
                self.editMode = true;
                self.enableViewMode = false;
                self.getSnapGender();
            } else {
                self.selectedSnapGender = [{
                    snapGenderList: []
                }];
                self.showActions = false;
                self.enableViewMode = false;
                self.getSnapGender();
            }
            if (self.selectedSnapGender[0].snapGenderList.length > 0) {
                self.selectedGender = self.selectedSnapGender[0].snapGenderList[0].name;
            }
        };

        self.initComponent();
    }
});
